import ValidationUtil from '../utils/ValidationUtil'

const inputs = {
  ssn: [
    {
      value: '442-44-9092',
      valid: true
    },
    {
      value: '234-99-2210',
      valid: true
    },
    {
      value: '42ee-482-4742',
      valid: false
    },
    {
      value: '372982263',
      valid: true
    },
    {
      value: '34332424245528528258',
      valid: false
    },
    {
      value: 'abcdefghiakdlhdafsdf',
      valid: false
    },
    {
      value: '$%#^$$&(#%^$&*(&*)%^($*',
      valid: false
    },
    {
      value: '',
      valid: false
    }
  ],
  ein: [
    {
      value: '34-3937492',
      valid: true
    },
    {
      value: '998472340',
      valid: true
    },
    {
      value: '980e92834',
      valid: false
    },
    {
      value: 'jjjeeiwas',
      valid: false
    },
    {
      value: '',
      valid: false
    }
  ],
  shortDate: [
    {
      value: '12/31',
      valid: true
    },
    {
      value: '01/31',
      valid: true
    },
    {
      value: '13/22',
      valid: false
    },
    {
      value: '01/40',
      valid: false
    },
    {
      value: '40/40',
      valid: false
    },
    {
      value: 'abdedfggafgasdfa',
      valid: false
    },
    {
      value: '231313452',
      valid: false
    },
    {
      value: 'abdc33234ed',
      valid: false
    },
    {
      value: '',
      valid: false
    }
  ],
  standardDate: [
    {
      value: '01/01/1990',
      valid: true
    },
    {
      value: '03/01/2018',
      valid: true
    },
    {
      value: '02/18',
      valid: false
    },
    {
      value: '20/19',
      valid: false
    },
    {
      value: 'asbcdasdwed',
      valid: false
    },
    {
      value: '1010',
      valid: false
    },
    {
      value: '4538',
      valid: false
    },
    {
      value: 31413,
      valid: false
    },
    {
      value: '',
      valid: false
    }
  ],
  zip: [
    {
      value: '04283',
      valid: true
    },
    {
      value: '91330',
      valid: true
    },
    {
      value: '38472',
      valid: true
    },
    {
      value: 'abd42',
      valid: false
    },
    {
      value: '*4223',
      valid: false
    },
    {
      value: 'gcdefgk',
      valid: false
    },
    {
      value: '33242414',
      valid: false
    },
    {
      value: '332234',
      valid: false
    },
    {
      value: '//#!!!!$',
      valid: false
    },
    {
      value: '*****',
      valid: false
    },
    {
      value: '',
      valid: false
    }
  ],
  number: [
    {
      value: '3123441453',
      valid: true
    },
    {
      value: '10',
      valid: true
    },
    {
      value: '1.0',
      valid: false
    },
    {
      value: '0.33123',
      valid: false
    },
    {
      value: '13491',
      valid: true
    },
    {
      value: '1313a331',
      valid: false
    },
    {
      value: 'bbc3ad',
      valid: false
    },
    {
      value: '$%^',
      valid: false
    },
    {
      value: '',
      valid: false
    }
  ],
  state: [
    {
      value: 'california',
      valid: false
    },
    {
      value: '\n/n',
      valid: false
    },
    {
      value: 'PA',
      valid: true
    },
    {
      value: 'GC',
      valid: false
    },
    {
      value: 'asfdasdfadf$@#$$',
      valid: false
    },
    {
      value: 'GA',
      valid: true
    },
    {
      value: 'CA',
      valid: true
    }
  ]
}

describe('ValidationUtil', () => {
  it('should validate ssn input', () => {
    for (const ssn of inputs.ssn) {
      expect(ValidationUtil.validate(ssn.value, 'ssn')).toEqual(ssn.valid)
    }
  })
  it('should validate ein input', () => {
    for (const ein of inputs.ein) {
      expect(ValidationUtil.validate(ein.value, 'ein')).toEqual(ein.valid)
    }
  })
  it('should validate short dates ex: 12/31', () => {
    for (const shortDate of inputs.shortDate) {
      expect(ValidationUtil.validate(shortDate.value, 'shortDate')).toEqual(shortDate.valid)
    }
  })
  it('should validate standard dates ex: 12/31/2017', () => {
    for (const standardDate of inputs.standardDate) {
      expect(ValidationUtil.validate(standardDate.value, 'standardDate')).toEqual(standardDate.valid)
    }
  })
  it('should validate zip code input', () => {
    for (const zip of inputs.zip) {
      expect(ValidationUtil.validate(zip.value, 'zip')).toEqual(zip.valid)
    }
  })
  it('should validate numeric input', () => {
    for (const number of inputs.number) {
      expect(ValidationUtil.validate(number.value, 'number')).toEqual(number.valid)
    }
  })
  it('should validate abbreviated states', () => {
    for (const state of inputs.state) {
      expect(ValidationUtil.validate(state.value, 'state')).toEqual(state.valid)
    }
  })
})